import { render } from "./TaskList.vue?vue&type=template&id=2cd7c8b0&scoped=true"
import script from "./TaskList.vue?vue&type=script&lang=js"
export * from "./TaskList.vue?vue&type=script&lang=js"

import "./TaskList.vue?vue&type=style&index=0&id=2cd7c8b0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2cd7c8b0"

export default script